import { Link } from "react-router-dom";
import styles from "./Navbar.module.scss";

const Navbar = () => {
    return (
        <div className={styles.container}>
            <Link to={'/'} style={{ textDecoration: "none", color: "white" }}>Zbox Legal SPA</Link>
        </div>
    );
};

export default Navbar;